module.exports = __webpack_public_path__ + "img/logo.75a5d14e.svg";